<template>
  <div>
    <p>{{ $t('You have been registered as a freelancer without a company.') }}</p>
    <BusinessEntityInput
      v-model="socialSecurityNo"
      :label="$t('Social Security number')"
      name="business_settings[cpr]"
    />
    <input type="hidden" name="business_entity" value="b_income" />

    <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
    <SubmitButton class="m-t-20" :text="$t('Save')" auto-submit :disabled="!canSave" />
  </div>
</template>

<script>
/* eslint-disable import/extensions */
import { computed, reactive } from 'vue'
import BusinessEntityInput from '@/components/compliances/BusinessEntity/BusinessEntityInput.vue'
import { setdefault } from '@/utils/tools'

export default {
  components: {
    BusinessEntityInput,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
  },
  emits: ['update:businessEntity'],
  setup(props, { emit }) {
    const internalBusinessEntity = reactive(props.businessEntity)
    const socialSecurityNo = computed({
      get: () => internalBusinessEntity.data?.cpr,
      set: (val) => {
        const data = setdefault(internalBusinessEntity, 'data', {})
        data.cpr = val
        emit('update:businessEntity', internalBusinessEntity)
      },
    })

    return {
      internalBusinessEntity,
      socialSecurityNo,
      canSave: computed(() => !!socialSecurityNo.value),
    }
  },
}
</script>
